import React from "react";
import useElements from "../hooks/useElements";
import { LogoProps } from "./logo-types";
import { WuiltContext } from "@wuilt/section-preview";

const Logo = (props: LogoProps) => {
  const { value, pages, className, noLink = false } = props;
  const { base } = useElements() as WuiltContext;
  const Image = base?.Image;
  const PageLink = base?.PageLink;

  const imageUrl = typeof value === "string" ? value : value.url;
  const logoSize =
    value.size === "small"
      ? "30px"
      : value.size === "large"
      ? "80px"
      : value.size === "xlarge"
      ? "120px"
      : "50px";

  if (noLink) {
    return (
      <Image
        className={className}
        style={{ maxWidth: "100%", height: logoSize, maxHeight: logoSize }}
        src={imageUrl || {}}
      />
    );
  }

  const homePage = pages?.find?.((page) => page.home_page);
  return (
    <PageLink page={homePage} style={{ pointerEvents: "auto" }}>
      <Image
        className={className}
        style={{ maxWidth: "100%", height: logoSize, maxHeight: logoSize }}
        src={imageUrl}
      />
    </PageLink>
  );
};

export default Logo;
